import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const OpportunitySplashPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("loan-details", { replace: true });
  });

  return <></>;
};

export default OpportunitySplashPage;
